import { createSelector } from 'reselect';

const getDeviceSettings = state => state.devices;

export { getDeviceSettings };
